/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Status_Incidents_OngoingInputs */



/**
* | output |
* | --- |
* | "Ongoing" |
*
* @param {Partner_Status_Incidents_OngoingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_status_incidents_ongoing = /** @type {((inputs?: Partner_Status_Incidents_OngoingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Status_Incidents_OngoingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Laufend")
	return /** @type {LocalizedString} */ ("Ongoing")
});